import axios from 'axios'
import store from "@/store"
import cryptoJS from "@js/cryptoJS.js";
import Toast from "@/components/toast"
import appInteraction from '@/common/appInteraction'
const errCodeApp = [9612, 9621, 9622, 9623, 9624, 9625, 9626, 9627, 9628, 9629, 9630, 9631, 9632, 9633, 9634, 9635, 9636, 9637, 9638, 9639, 9111, 9221];
// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API_URL, // api 的 base_url
  timeout: 15000, // 请求超时时间
  headers: {
    "Content-Type": "application/json; charset=utf-8",
    "Accept-Language": "zh-CN"
  }
})
// request拦截器
service.interceptors.request.use(
  config => {
    let AppInfo = store.state.AppInfo;
    let Timestamp = config.data.Timestamp;
    let token = config.data.TemporaryToken || store.state.token;
    config.headers['Request-ID'] = '';
    config.headers['Timestamp'] = Timestamp;
    config.headers['Client-ID'] = AppInfo.ClientId;
    config.headers['Request_Now_Version'] = AppInfo.RequestNowVersion;
    config.headers['Session-ID'] = token;

    delete config.data.TemporaryToken;
    delete config.data.Timestamp;
    if (config.method === 'post') {
      if (!config.data) { // 没有参数时，config.data为null，需要转下类型
        config.data = {};
      }
      config.data = JSON.stringify(config.data);
    }
    config.headers['Digest'] = cryptoJS.SHA256(config.url + Timestamp + AppInfo.RequestDigestKey + config.data);
    return config
  },
  error => {
    Toast("服务器异常", "error");
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    if (response.status !== 200) {
      Toast("服务器异常", "error");
      return Promise.reject(response.data);
    } else {
      if (response.data.Code === 0) {
        var AppInfo = store.state.AppInfo;
        var resDigest = response.headers["digest"],
          resTimestamp = response.headers["timestamp"],
          digest2 = cryptoJS.SHA256(response.config.url + resTimestamp + AppInfo.ResponseDigestKey + response.request.response);
        if (resDigest == digest2) {
          return response;
        } else {
          response.data = { Code: 9411, Message: "签名验证失败" };
          return response;
        }
      } else {
        return response;
      }
    }
  },
  err => {
    var response = err.response;
    Toast("服务器异常", "error");
    return Promise.reject(response);
  }
)
//post
/**
 * @param {*} url 
 * @param {*} params 
 * @param {
 * * isEncrypt Boolean
 * * isDecrypt Boolean
 * * loading Boolean|String
 * * code Array|Boolean
 * * refresh Boolean
 * } option 
 * isEncrypt：为true 对参数进行加密（只操作参数名带下划线_的）
 * isDecrypt：为true 对响应数据进行解密（只操作参数名带下划线_的）
 * loading：为true 调用接口出现loading图片 可填写文字
 * code：需要响应后特殊操作的code，不弹出错误提示message。为true 所有错误不弹出提示
 * refresh: 为true token失效，响应app原生登录成功刷新页面
 * @returns 
 */
export function post(url, params = {}, option = {}) {
  if (option.loading) Toast(typeof option.loading == 'boolean' ? "" : option.loading, "loading");
  return new Promise((resolve, reject) => {
    appInteraction.getAppData().then(serve => {
      let Timestamp = serve.Timestamp;
      if (option.isEncrypt) {
        params = cryptoJS.RequestEncrypt(params, Timestamp);
      }
      params.Timestamp = Timestamp;
      service.post(url, params).then(response => {
        var data = response.data;
        if (option.loading) Toast("hideLoading");
        if (data.Code == 0) {
          if (option.isDecrypt) {
            data = cryptoJS.ResponseDecrypt(data, response.headers.timestamp);
          }
        } else {
          let isArray = Array.isArray(option.code) && (option.code.length == 0 || !option.code.includes(data.Code));
          if (!option.code || isArray) {
            Toast(data.Message || ("服务器异常,error:" + data.Code), "error");
          }
          if (errCodeApp.includes(response.data.Code)) {
            appInteraction.requestError(response.data.Code);
            if (option.refresh) {
              appInteraction.loginSuccess().then(() => {
                location.reload();
              })
            } else {
              appInteraction.loginSuccess();
            }
          }
        }
        resolve(data);
      }).catch(err => {
        if (option.loading) Toast("hideLoading");
        reject(err);
      })
    })
  })
}

